import { DatasetDefinition, DocumentSpecificHiddenFields, HiddenFields } from '../../../datasets/store/types';
import { ClientDatasets } from '../../client-datasets/store/types';
import { MyRiskTolerance, RiskTolerance, SelectedRiskField, UpdatedRiskField } from '../../risk-tolerance/store/types';

export enum ClientRiskToleranceActionTypes {
    FETCH_ALL_CLIENT_RISK_TOLERANCE_DATASETS_STARTED = 'FETCH_ALL_CLIENT_RISK_TOLERANCE_DATASETS_STARTED',
    FETCH_ALL_CLIENT_RISK_TOLERANCE_DATASETS_SUCCESSFUL = 'FETCH_ALL_CLIENT_RISK_TOLERANCE_DATASETS_SUCCESSFUL',
    FETCH_ALL_CLIENT_RISK_TOLERANCE_DATASETS_FAILED = 'FETCH_ALL_CLIENT_RISK_TOLERANCE_DATASETS_FAILED',
    CLIENT_RISK_TOLERANCE_VIEW = 'CLIENT_RISK_TOLERANCE_VIEW',
    FETCH_CLIENT_RISK_TOLERANCE_DATASET_DEFINITIONS_STARTED = 'FETCH_CLIENT_RISK_TOLERANCE_DATASET_DEFINITIONS_STARTED',
    FETCH_CLIENT_RISK_TOLERANCE_DATASET_DEFINITIONS_SUCCESSFUL = 'FETCH_CLIENT_RISK_TOLERANCE_DATASET_DEFINITIONS_SUCCESSFUL',
    FETCH_CLIENT_RISK_TOLERANCE_DATASET_DEFINITIONS_FAILED = 'FETCH_CLIENT_RISK_TOLERANCE_DATASET_DEFINITIONS_FAILED',
    RESET_CLIENT_RISK_TOLERANCE_DATASETS = 'RESET_CLIENT_RISK_TOLERANCE_DATASETS',
    SET_CURRENT_RISK_TOLERANCE_FIELD = 'SET_CLIENT_CURRENT_RISK_TOLERANCE_FIELD',
    UPDATE_RISK_FIELD_CONFIG = 'UPDATE_CLIENT_RISK_FIELD_CONFIG',
    UPDATE_RISK_FIELD_WEIGHTING = 'UPDATE_CLIENT_RISK_FIELD_WEIGHTING',
    UPDATE_RISK_FIELD_FALLBACK_RISK_POSITION = 'UPDATE_CLIENT_RISK_FIELD_FALLBACK_RISK_POSITION',
    TOGGLE_CLIENT_RISK_FIELD = 'TOGGLE_CLIENT_RISK_FIELD',
    SAVE_CLIENT_RISK_TOLERANCE_STARTED = 'SAVE_CLIENT_RISK_TOLERANCE_STARTED',
    SAVE_CLIENT_RISK_TOLERANCE_SUCCESSFUL = 'SAVE_CLIENT_RISK_TOLERANCE_SUCCESSFUL',
    SAVE_CLIENT_RISK_TOLERANCE_FAILED = 'SAVE_CLIENT_RISK_TOLERANCE_FAILED',
    SET_RISK_TOLERANCE_UPDATED = 'SET_CLIENT_RISK_TOLERANCE_UPDATED',
    SET_DATASET_DOCUMENT_RISK_TOLERANCE_RECALCULATING = 'SET_CLIENT_DATASET_DOCUMENT_RISK_TOLERANCE_RECALCULATING',
    TOGGLE_UNSAVED_CHANGES_MODAL = 'TOGGLE_CLIENT_RISK_TOLERANCE_DATASETS_UNSAVED_CHANGES_MODAL',
    TOGGLE_RISK_FIELDS_UPDATED_MODAL = 'TOGGLE_RISK_FIELDS_UPDATED_MODAL',
    SET_RISK_TOLERANCE_RISK_FIELDS_UPDATED = 'SET_CLIENT_RISK_TOLERANCE_RISK_FIELDS_UPDATED'
}

export enum ClientRiskToleranceView {
    LIST = 'List',
    CONFIGURE = 'Configure'
}

export interface ClientRiskToleranceState {
    allDatasets: ClientDatasets[];
    fetchingAllDatasets: boolean;
    riskToleranceView: ClientRiskToleranceView;
    selectedDataset: number | null;
    datasetDefinitions: DatasetDefinition[];
    hiddenFields: HiddenFields;
    documentHiddenFields: DocumentSpecificHiddenFields;
    isSaving: boolean;
    clientRiskToleranceConfig: (RiskTolerance | MyRiskTolerance)[] | null;
    currentRiskToleranceConfig: (RiskTolerance | MyRiskTolerance)[] | null;
    riskToleranceIsRecalculating: boolean;
    riskToleranceIncludesOverrides: boolean;
    currentRiskField: SelectedRiskField | null;
    riskToleranceUpdated: boolean;
    unsavedChangesModalOpen: boolean;
    fetchingDatasetDefinitions: boolean;
    riskFieldsUpdatedModalOpen: boolean;
    riskFieldsUpdated: UpdatedRiskField[];
}
